/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "vpos": {
                                "nested": {
                                  "Checkout": {
                                    "fields": {
                                      "forPaperSignatureUseQuickTipReceipt": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "taxEnabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "taxRate": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "useCuratedImageForReceipt": {
                                        "type": "bool",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "optedIntoOpenTicketsPreview": {
                                        "type": "bool",
                                        "id": 5,
                                        "rule": "optional"
                                      },
                                      "forOpenTicketsSendDailyDeletionEmail": {
                                        "type": "bool",
                                        "id": 6,
                                        "rule": "optional"
                                      },
                                      "useAllowSwipeForChipCards": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional"
                                      },
                                      "customTenderOptionsProto": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                      },
                                      "useInstantDeposits": {
                                        "type": "bool",
                                        "id": 9,
                                        "rule": "optional"
                                      },
                                      "allowInstantDeposit": {
                                        "type": "bool",
                                        "id": 10,
                                        "rule": "optional"
                                      },
                                      "useBuyerFacingScreen": {
                                        "type": "bool",
                                        "id": 11,
                                        "rule": "optional"
                                      },
                                      "showBuyerFacingOrderSummary": {
                                        "type": "bool",
                                        "id": 12,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.vpos?.nested?.Checkout) {
  $root.addJSON(jsonData);
}

/**
 * Do not use this checkout proto as it is a relic of V1 device profile fields
 * that were not represented of V2 at the time the V2 protos were introduced. If fields
 * below are to be used in V2, a new equivalent DPv2 proto should be defined.
 *
 * SOURCE Checkout @ squareup/devicesettings/profiles/v2/model/settings/common/vpos/checkout.proto at 14:1
 */
export const Checkout = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.vpos.Checkout');
fixType(Checkout);
Builder.createAndAttachToType(Checkout);